$(function() {
    $('.js-form-lost-password').validate({
        submitHandler: function(form) {
            form.submit();
        }
    });
});